import React from "react";
import { useTranslation } from "react-i18next";

export const TermsAndConditions = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex-grow">
        <p className="mb-6 text-black text-[16px] font-light leading-[22.4px] tracking-[0.2px]">
          {t(
            "Please carefully read and accept the following declarations before starting the exam.",
          )}
        </p>
        <ul className="list-disc list-inside space-y-4 mb-6 text-black text-[16px] font-light leading-[22.4px] tracking-[0.2px]">
          <li className="list-none">
            {t(
              "I declare that the login credentials I received have not been shared with third parties, and during the exam I will:",
            )}
          </li>
          <ul className="list-disc ml-6 space-y-2">
            <li>{t("Ensure complete independence in my work,")}</li>
            <li>{t("Not use assistance from third parties,")}</li>
            <li>{t("Not use any supplementary materials,")}</li>
            <li>{t("Not use any auxiliary devices,")}</li>
            <li>{t("Not record or document the exam in any form.")}</li>
          </ul>
          <li className="list-none">
            {t("I declare that before the exam, I was informed by the Insurance Company about:")}
          </li>
          <ul className="list-disc ml-6 space-y-2">
            <li>{t("Organizational conditions and methods of conducting the exam,")}</li>
            <li>{t("Rules applicable during the exam,")}</li>
            <li>{t("Methods of evaluating responses,")}</li>
            <li>{t("Ways of communicating exam results.")}</li>
          </ul>
          <li className="list-none">
            {t(
              "I declare that the information I provided before the exam, including the email address used to receive login credentials, is accurate and up-to-date.",
            )}
          </li>
          <li className="list-none">
            {t(
              "Upon accepting these declarations, at the designated start time, the Participant can begin completing the Test.",
            )}
          </li>
        </ul>
      </div>
    </>
  );
};
